import { service } from '../../../../helpers/http' 

export const ActionGetSmartshare = ({ dispatch }, payload) => { 
    return service({
        module: 'domainSmartshare',
        action: 'getSmartshare',
        payload: payload
    })
}

export const ActionPostSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'postSmartshare',
        payload: payload
    })
    
}

export const ActionPutSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'putSmartshare',
        payload: payload
    })
    
}

export const ActionDeleteSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'deleteSmartshare',
        payload: payload
    })
    
}

// GED Config Actions
export const ActionGetGedProviders = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'getGedProviders',
        payload: payload
    })
}

export const ActionGetGedConfig = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'getGedConfig',
        payload: payload
    })
}

export const ActionPutGedConfig = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'putGedConfig',
        payload: payload
    })
}

export const ActionPostGedTestConnection = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'postGedTestConnection',
        payload: payload
    })
}

export const ActionGetGedTransfers = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'getGedTransfers',
        payload: payload
    })
}

export const ActionGetGedStats = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'getGedStats',
        payload: payload
    })
}

export const ActionPostGedRetryTransfer = ({ dispatch }, payload) => {
    return service({
        module: 'domainSmartshare',
        action: 'postGedRetryTransfer',
        payload: payload
    })
}
